import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";

const DeleteEmployeeInSite = ({ confirm, closeDialog, open }) => {
  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        keepMounted
        onClose={closeDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogTitle id="alert-dialog-slide-description">
            <span>Se van a eliminar los usuarios seleccionados</span>
          </DialogTitle>
          <ConfirmButtons
            accept={confirm}
            cancel={closeDialog}
            acceptTitle="Confirmar"
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default DeleteEmployeeInSite;
